












import {Component, Prop, Vue} from 'vue-property-decorator'
import Sidebar from '@/components/Sidebar.vue'

@Component({
  components: {Sidebar},
})
export default class AuthLayout extends Vue {
  authorized = false

  async mounted() {
    await this.$auth.authenticate()
    this.authorized = true
  }
}
